import axios from 'axios'

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000'

// Создаем инстанс axios для staff API
const staffApi = axios.create({
  baseURL: `${API_BASE_URL}/api/admin/staff/`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

// Helper function to get CSRF token from cookie
function getCookie(name) {
  let cookieValue = null
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim()
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
        break
      }
    }
  }
  return cookieValue
}

// Интерсепторы для обработки ошибок
staffApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token')
    if (token) {
      config.headers.Authorization = `Token ${token}`
    }

    // Добавляем CSRF токен из cookie
    const csrfToken = getCookie('csrftoken')
    if (csrfToken) {
      config.headers['X-CSRFToken'] = csrfToken
    }

    // Для FormData убираем Content-Type чтобы браузер сам установил boundaries
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }


    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

staffApi.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response) {

      if (error.response.status === 401) {
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('user_name')
        window.location.href = '/login'
      }
      else if (error.response.status === 500) {
      }
    } else if (error.request) {
    } else {
      // No action needed
    }

    return Promise.reject(error)
  }
)

// API методы для персонала
export default {
  // Проверка доступа персонала
  async checkStaffAccess() {
    try {
      await staffApi.get('dashboard_stats/')
      return { hasAccess: true }
    } catch (error) {
      return {
        hasAccess: false,
        error: error.response?.data?.detail || 'Доступ запрещен. Требуются права персонала.'
      }
    }
  },

  // Dashboard статистика для персонала
  async getDashboardStats() {
    return staffApi.get('dashboard_stats/')
  },

  // === ЛОКАЦИИ ===

  // Получить все локации
  async getLocations() {
    const response = await staffApi.get('locations/')
    return { cities: response.data }
  },

  // Получить районы по городу
  async getDistricts(cityId = null) {
    const params = cityId ? { city: cityId } : {}
    const response = await staffApi.get('../../districts/', { params })
    return response.data
  },


  // Создать новый город
  async createCity(name_kz, name_ru) {
    return staffApi.post('create_city/', {
      name_kz: name_kz,
      name_ru: name_ru
    })
  },

  // Обновить название города
  async updateCity(id, cityData) {
    return staffApi.put(`${id}/update_city/`, {
      name_kz: cityData.name_kz,
      name_ru: cityData.name_ru
    })
  },

  // Удалить город
  async deleteCity(id) {
    return staffApi.delete(`${id}/delete_city/`)
  },

  // Создать новую поликлинику
  async createClinic(data) {
    return staffApi.post('create_clinic/', data)
  },

  // Создать новый участок


  // === МЕДПЕРСОНАЛ ===

  // Получить список медперсонала
  async getMedicalStaff(params = {}) {
    const response = await staffApi.get('medical_staff/', { params })
    return response.data
  },

  // === ПЕРСОНАЛ (главврачи и администраторы учреждений) ===
  async getManagementUsers(params = {}) {
    const response = await staffApi.get('management_users/', { params })
    return response.data
  },
  async getStaffUserDetails(id) {
    const response = await staffApi.get(`${id}/staff_user_details/`)
    return response.data
  },
  async updateStaffUser(id, data) {
    return staffApi.put(`${id}/update_staff_user/`, data)
  },
  async deleteStaffUser(id) {
    return staffApi.delete(`${id}/delete_staff_user/`)
  },
  async createStaffUser(data) {
    return staffApi.post('create_staff_user/', data)
  },

  // === ПАЦИЕНТЫ ===

  // Получить список пациентов
  async getPatients(params = {}) {
    const response = await staffApi.get('patients_list/', { params })
    return response.data  // Возвращаем полный ответ с пагинацией
  },

  // === СОЗДАНИЕ ПОЛЬЗОВАТЕЛЕЙ ===

  // Создать нового врача
  async createDoctor(data) {
    return staffApi.post('create_doctor/', data)
  },

  // Создать новую медсестру
  async createNurse(data) {
    return staffApi.post('create_nurse/', data)
  },

  // Создать нового пациента
  async createPatient(data) {
    return staffApi.post('create_patient/', data)
  },

  // === ОБНОВЛЕНИЕ ПОЛЬЗОВАТЕЛЕЙ ===

  // Обновить данные врача
  async updateDoctor(id, data) {

    try {
      const response = await staffApi.put(`${id}/update_doctor/`, data)
      return response
    } catch (error) {
      throw error
    }
  },

  // Обновить данные медсестры
  async updateNurse(id, data) {

    try {
      const response = await staffApi.put(`${id}/update_nurse/`, data)
      return response
    } catch (error) {
      throw error
    }
  },

  // Обновить данные пациента
  async updatePatient(id, data) {

    try {
      const response = await staffApi.put(`${id}/update_patient/`, data)
      return response
    } catch (error) {
      throw error
    }
  },

  // Обновить поликлинику
  async updateClinic(data) {
    return staffApi.put(`update_clinic/${data.id}`, data)
  },

  // Обновить участок

  // === УДАЛЕНИЕ ПОЛЬЗОВАТЕЛЕЙ (УСТАРЕЛО - используйте деактивацию через update методы) ===

  // Удалить врача (УСТАРЕЛО: используйте updateDoctor с is_active: false)
  async deleteDoctor(id) {
    return staffApi.delete(`${id}/delete_doctor/`)
  },

  // Удалить медсестру (УСТАРЕЛО: используйте updateNurse с is_active: false)
  async deleteNurse(id) {
    return staffApi.delete(`${id}/delete_nurse/`)
  },

  // Удалить пациента (УСТАРЕЛО: используйте updatePatient с is_active: false)
  async deletePatient(id) {
    return staffApi.delete(`${id}/delete_patient/`)
  },

  // === ДЕАКТИВАЦИЯ ПОЛЬЗОВАТЕЛЕЙ ===
  // Для деактивации используйте соответствующие update методы с параметром { is_active: false }
  // Например: await staffApi.updateDoctor(id, { is_active: false })

  // === ПОЛУЧЕНИЕ ДАННЫХ ПОЛЬЗОВАТЕЛЕЙ ===

  // Получить подробные данные врача
  async getDoctorDetails(id) {
    const response = await staffApi.get(`${id}/doctor_details/`)
    return response.data
  },

  // Получить подробные данные медсестры
  async getNurseDetails(id) {
    const response = await staffApi.get(`${id}/nurse_details/`)
    return response.data
  },

  // Получить подробные данные пациента
  async getPatientDetails(id) {
    const response = await staffApi.get(`${id}/patient_details/`)
    return response.data
  },

  // === УТИЛИТЫ ===

  // Форматирование даты
  formatDate(dateString) {
    if (!dateString) return '—'
    try {
      const date = new Date(dateString)
      return date.toLocaleDateString('ru-RU', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    } catch (error) {
      return dateString
    }
  },

  // Форматирование чисел
  formatNumber(value) {
    if (!value && value !== 0) return '—'
    return new Intl.NumberFormat('ru-RU').format(value)
  },

  // Иконки для типов пользователей
  getUserTypeIcon(userType) {
    const icons = {
      'doctor': '👨‍⚕️',
      'nurse': '👩‍⚕️',
      'patient': '👤',
      'admin': '👑'
    }
    return icons[userType] || '👤'
  },

  // Цвета для статусов
  getStatusColor(isActive) {
    return isActive ? 'text-green-600' : 'text-red-600'
  },

  // Цвета для типов пользователей
  getTypeColor(userType) {
    const colors = {
      'doctor': 'bg-blue-100 text-blue-800',
      'nurse': 'bg-green-100 text-green-800',
      'patient': 'bg-gray-100 text-gray-800',
      'admin': 'bg-purple-100 text-purple-800'
    }
    return colors[userType] || 'bg-gray-100 text-gray-800'
  },

  // Скачивание файлов
  downloadFile(data, filename) {
    const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  },

  // === ТИПЫ ТРЕКЕРОВ ЗДОРОВЬЯ ===

  // Получить список типов трекеров
  async getHealthTrackerTypes(params = {}) {
    const response = await staffApi.get('health_tracker_types/', { params })
    return response.data
  },

  // Создать новый тип трекера
  async createTrackerType(data) {
    return staffApi.post('create_tracker_type/', data)
  },

  // Обновить тип трекера
  async updateTrackerType(data) {
    return staffApi.put(`${data.id}/update_tracker_type/`, data)
  },

  // Удалить тип трекера
  async deleteTrackerType(id) {
    return staffApi.delete(`${id}/delete_tracker_type/`)
  },

  // Health Trackers API
  async getTrackerTypes(params = {}) {
    return staffApi.get('tracker_types/', { params })
  },

  // Visit Reasons API
  async getVisitReasons(params = {}) {
    return staffApi.get('visit_reasons/', { params })
  },

  async createVisitReason(data) {
    return staffApi.post('visit_reasons/', data)
  },

  async updateVisitReason(data) {
    return staffApi.put('update_visit_reason/', data)
  },

  async deleteVisitReason(id) {
    return staffApi.delete('delete_visit_reason/', { params: { id } })
  },

  // ===============================================
  // НОВЫЕ ЭНДПОИНТЫ ДЛЯ /api/staff/*
  // (Для врачей и персонала в веб-приложении)
  // ===============================================

  // === APPOINTMENTS для врачей/персонала ===

  // Получить все приемы врача/персонала (БЕЗ приемов где он пациент)
  async getStaffAppointments(params = {}) {
    const response = await staffApi.get('../../staff/appointments/', { params })
    return response
  },

  // Получить приемы на сегодня (врач/персонал)
  async getStaffTodayAppointments() {
    const response = await staffApi.get('../../staff/appointments/today/')
    return response
  },

  // Получить предстоящие приемы (врач/персонал)
  async getStaffUpcomingAppointments() {
    const response = await staffApi.get('../../staff/appointments/upcoming/')
    return response
  },

  // Получить прошлые приемы (врач/персонал)
  async getStaffPastAppointments() {
    const response = await staffApi.get('../../staff/appointments/past/')
    return response
  },

  // Получить мои приемы как врач/медсестра
  async getMyStaffAppointments(params = {}) {
    const response = await staffApi.get('../../staff/appointments/my_appointments/', { params })
    return response
  },

  // Получить настройки причин и цен для врача (коммерческие клиники)
  async getDoctorVisitReasonsConfig(params = {}) {
    const response = await staffApi.get('../../staff/appointments/doctor-visit-reasons/', { params })
    return response
  },

  // Сохранить настройки причин и цен для врача (коммерческие клиники)
  async updateDoctorVisitReasonsConfig(data) {
    const response = await staffApi.put('../../staff/appointments/doctor-visit-reasons/', data)
    return response
  },

  // Получить приемы пациентов организаций текущего врача
  async getStaffOrganizationAppointments(params = {}) {
    const response = await staffApi.get('../../staff/appointments/organization_appointments/', { params })
    return response
  },

  // Обновить статус приема
  async updateStaffAppointmentStatus(appointmentId, status) {
    const response = await staffApi.patch(
      `../../staff/appointments/${appointmentId}/`,
      { status }
    )
    return response
  },

  // Обновить статус бронирования (для менеджера/администратора коммерческой клиники)
  async updateAppointmentBookingStatus(appointmentId, bookingStatus) {
    const response = await staffApi.post(
      `../../staff/appointments/${appointmentId}/booking-status/`,
      { booking_status: bookingStatus }
    )
    return response
  },

  // Начать прием
  async startStaffAppointment(appointmentId) {
    const response = await staffApi.post(
      `../../staff/appointments/${appointmentId}/start_appointment/`,
      {}
    )
    return response
  },

  // Завершить прием
  async completeStaffAppointment(appointmentId, data) {
    const response = await staffApi.post(
      `../../staff/appointments/${appointmentId}/complete_appointment/`,
      data
    )
    return response
  },

  // Обновить данные видеокомнаты приема
  async updateStaffAppointmentVideoRoom(appointmentId, videoRoomData) {
    const payload = {};

    // Include status if provided
    if (videoRoomData.status) {
      payload.status = videoRoomData.status;
    }

    // Only include properties that exist in the videoRoomData with correct field names
    if (videoRoomData.video_room_url || videoRoomData.url) {
      payload.video_room_url = videoRoomData.video_room_url || videoRoomData.url;
    }

    if (videoRoomData.video_room_name || videoRoomData.room_name) {
      payload.video_room_name = videoRoomData.video_room_name || videoRoomData.room_name;
    }

    // Don't make the API call if we have no data to update
    if (Object.keys(payload).length === 0) {
      return Promise.resolve({ data: null });
    }

    const response = await staffApi.patch(
      `../../staff/appointments/${appointmentId}/`,
      payload
    )
    return response
  },

  // Синхронизировать URL видеокомнаты в МИС
  async syncUrlToMIS(appointmentId) {
    const response = await staffApi.post(
      `../../staff/appointments/${appointmentId}/sync-url-to-mis/`,
      {}
    )
    return response
  },

  // Синхронизировать данные завершения приема в МИС (video_record, chat_history)
  async syncCompletionToMIS(appointmentId) {
    const response = await staffApi.post(
      `../../staff/appointments/${appointmentId}/sync-completion-to-mis/`,
      {}
    )
    return response
  },

  // Получить текущий статус доступа к медиа приема
  async getAppointmentMediaAccess(appointmentId) {
    const response = await staffApi.get(
      `../../staff/appointments/${appointmentId}/media-access/`
    )
    return response
  },

  // Отправить пациенту запрос на доступ к видео/чату приема
  async requestAppointmentMediaAccess(appointmentId) {
    const response = await staffApi.post(
      `../../staff/appointments/${appointmentId}/media-access/request/`,
      {}
    )
    return response
  },

  // Получить записи видео приема через защищенный backend endpoint
  async getAppointmentMediaRecords(appointmentId) {
    const response = await staffApi.get(
      `../../staff/appointments/${appointmentId}/media-records/`
    )
    return response
  },

  // Получить историю чата приема через защищенный backend endpoint
  async getAppointmentMediaChat(appointmentId) {
    const response = await staffApi.get(
      `../../staff/appointments/${appointmentId}/media-chat/`
    )
    return response
  },

  // === HEALTH TRACKERS для врачей/персонала ===

  // Получить трекеры пациентов клиники (БЕЗ личных трекеров врача)
  async getStaffHealthTrackers(filters = {}) {
    const response = await staffApi.get('../../staff/health-trackers/', { params: filters })
    return response
  },

  // Получить трекеры конкретного пациента
  async getPatientHealthTrackers(patientId) {
    const response = await staffApi.get('../../staff/health-trackers/', {
      params: { patient: patientId }
    })
    return response
  },

  // Получить статистику по трекерам пациента
  async getPatientHealthTrackerStats(patientId, metricType) {
    const response = await staffApi.get('../../staff/health-trackers/list_records/', {
      params: {
        patient: patientId,
        metric_type: metricType,
      }
    })
    return response
  },

  // === SURVEYS для врачей/персонала ===

  // Получить ответы на опросы конкретного пациента  
  async getPatientSurveyResponses(patientId) {
    const response = await staffApi.get(`../../surveys/responses/`, {
      params: { patient: patientId }
    })
    return response
  },
} 
